$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  const locationId = $("body").attr("event_id");

  if (p === "z_report") {
    let page = 1;

    $("#printer-id").select2({
        theme: 'bootstrap4',
    })

    $(document).on(
      "change",
      "#bankaksept, #visa, #mastercard, #othercard, #cash, #cash_deposit, #cash_takeout_spent, #cash_takeout_saved",
      function (e) {
        e.preventDefault();
        let totalAmount = 0;
        let posAmount = floor($("#total-pos-amount").attr("data-amount"));

        const cardIds = ["#nets", "#bankaksept", "#visa", "#mastercard", "#othercard"];
        cardIds.forEach(function (id) {
          totalAmount += parseNumberFromString($(id).val());
        });

        const cash = parseNumberFromString($("#cash").val());
        const cashDeposit = parseNumberFromString($("#cash_deposit").val());
        const cashTakeoutSpent = parseNumberFromString($("#cash_takeout_spent").val());
        const previousStartingBalance = parseNumberFromString($("#starting-balance").text());

        const totalCash = (cash + cashTakeoutSpent) - cashDeposit - previousStartingBalance;
        totalAmount += totalCash;

        calculateBalanceAdjustment();

        let diffAmount = floor(totalAmount - posAmount);

        $("#total-amount").text(formattedPriceToShow(totalAmount));
        $("#diff-amount").text(formattedPriceToShow(diffAmount));
      }
    );

    $(document).on("click", "#register-confirm", function (e) {
      $("#register-confirm").prop("disabled", true);
      $("#z-report-form").submit();
    });

    $(document).on("input", ".tips_input", function () {
        const totalTipsAmount = parseFloat($("#total-tips-amount").data("amount") || 0);
        const value = parseFloat($(this).val());

        if (!isNaN(value) && value > 0) {
            const total = totalTipsAmount + value;
            $("#total-tips-amount").text(formattedPriceToShow(total));
        }
    })

    function updateModalMessage(message) {
        const $modalMessage = $("#register-modal-text");
        $modalMessage.empty();
        $modalMessage.append(message);
    }

    $(document).on("click", "#register-cancel", function () {
        const button = $(this);
        const $modalMessage = button.attr("data-default-message");
        updateModalMessage($modalMessage);
    })

    $(document).on("submit", "#z-report-form", function (e) {
      e.preventDefault();
      const confirmButton = $("#register-confirm");
      updateModalMessage(confirmButton.attr("data-progress-message"));
      const buttonText = confirmButton.text();
      $("#register-cancel").prop("disabled", true);

      var disabled = $(this).find(':input:disabled').removeAttr('disabled');

      const formData = new FormData($(this)[0]);
      const printZreport = $("#print_z_report").is(":checked") ? 1 : 0;
      const reconciliateTerminal = $("#reconciliation-terminal").is(":checked");
      const organizerId = $(this).find('[name="organizer_id"]').val();

      disabled.attr('disabled', 'disabled');

      confirmButton.empty();
      confirmButton.append('<div class="loader"></div>');

      for (let [key, value] of formData.entries()) {
        // Check if the value is empty
        if (value === "") {
          formData.set(key, 0);
        } else if (typeof value === "string" && value.includes(",")) {
          formData.set(key, value.replace(",", "."));
        }
      }

      formData.append("location_id", locationId);
      formData.append("print_z_report", printZreport);
      formData.append("reconciliation_terminal", reconciliateTerminal);

      $.ajax({
        type: "POST",
        url: "/api/v1/private/z-report/new",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          const socketData = { type: "created_z_report", location_id: locationId, organizer_id: organizerId };

          if (printZreport && !window.ReactNativeWebView) {
              socketData.zReportData = { printData: data.printData, ipAddress: data.ipAddress, type: data.type, main_pos_device_id: data.mainPosDeviceId, printDocument: data.printDocument };
          }

          window.globalSocket.send(JSON.stringify(socketData))

          if (printZreport && window.ReactNativeWebView && data.type === 'VERIFONE') {
            passVerifoneDataToWebView({
              action: "verifone",
              data: {
                  action: "print",
                  data: {
                    document: data.printDocument,
                    contentTypeString: 'HTML',
                    receiptTypeString: 'DOCUMENT',
                    deliveryMethodString: 'PRINT',
                    deliveryAddress: ''
                  }
              }
            })
          } else if (printZreport && window.ReactNativeWebView) {
            passDataToWebView(
              e,
              "print_z_report",
              data.printData,
              data.ipAddress,
              data.type
            );
          } 

          if (
            data.error?.message &&
            data.error?.message !== null &&
            data.error?.message !== ""
          ) {
            showToast({
              type: "error",
              title: "Error",
              message: data.error.message,
              position: "top-right",
              duration: 4000,
            });
          }

          updateModalMessage("Dagsoppgjør er opprettet.")
          
          if (
            data.downloadUrl !== "" &&
            data.downloadUrl !== null &&
            data.downloadUrl !== undefined
          ) {
            window.location.href = data.downloadUrl;
          }

          if (data.redirect_url !== "" && data.redirect_url !== null && data.redirect_url !== undefined) {
              setTimeout(function () {
                  window.location.href = data.redirect_url;
                  $("div.loader").remove();
                  confirmButton.text(buttonText);
              }, 500);
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
              document.location.href = data.responseJSON.redirect_url;
          }
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Registrer");
          showToast({
            type: "error",
            title: "Error",
            message: data.responseJSON.error.message,
            position: "top-right",
            duration: 4000,
          });

          updateModalMessage(confirmButton.attr("data-error-message"));

          $("#register-confirm").prop("disabled", false);
          $("#register-cancel").prop("disabled", false);
        });
    });

    $(document).on("click", "#z-report-download-pdf", function () {
      const zReportId = $(this).attr("data-z-report-id");

      const disabledOnClick = $("#z-report-download-pdf");
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      const url = `/api/v1/z-report-public/download_pdf?z_report_id=${zReportId}&location_id=${locationId}`;
      window.location.href = url;

      disabledOnClick.prop("disabled", false);
      disabledOnClick.html("Last ned(pdf)");
    });

    $(document).on("click", "#print-zreport", function (e) {
      const zReportId = $(this).attr("data-z-report-id");
      const button = $(this);
      const buttonText = button.text();
      button.prop("disabled", true);

      button.empty();
      button.append('<div class="loader"></div>');

      $.ajax({
        type: "POST",
        url: "/api/v1/private/z-report/print",
        data: {
          z_report_id: zReportId,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data && data.printData && data.ipAddress && data.type === 'TERMINAL') {
            passDataToWebView(
              e,
              "print_z_report",
              data.printData,
              data.ipAddress,
              data.type
            );
          } else if (printZreport && window.ReactNativeWebView && data.type === 'VERIFONE') {
            passVerifoneDataToWebView({
              action: "verifone",
              data: {
                  action: "print",
                  data: {
                    document: data.printDocument,
                    contentTypeString: 'HTML',
                    receiptTypeString: 'DOCUMENT',
                    deliveryMethodString: 'PRINT',
                    deliveryAddress: ''
                  }
              }
            })
          }

          $("div.loader").remove();
          button.prop("disabled", false);
          button.text(buttonText);
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
              document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON !== undefined &&
            data.responseJSON.error.message !== undefined &&
            data.responseJSON.error.message !== null
          ) {
            showToast({
              type: "error",
              title: "Error",
              message: data.responseJSON.error.message,
              position: "top-right",
              duration: 4000,
            });
          }
          $("div.loader").remove();
          button.prop("disabled", false);
          button.text(buttonText);
        });
    });

    //start-end date filter
    $(document).on("change", "#start-date", function (e) {
      const startDate = $(this).val();
      const endDate = $("#end-date").val();

      if (checkDateValidation(startDate, endDate)) {
        getZreport(locationId, startDate, endDate);
      } else {
        $(this).focus();
        return;
      }
    });

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      const filterStartDate = $("#start-date").val();
      const filterEndDate = $("#end-date").val();
      page = parseInt($(this).attr("href").substring(6));
      getZreport(locationId, filterStartDate, filterEndDate, page);
    });

    $(document).on("change", "#end-date", function (e) {
      const endDate = $(this).val();
      const startDate = $("#start-date").val();

      if (checkDateValidation(startDate, endDate)) {
        getZreport(locationId, startDate, endDate);
      } else {
        $(this).focus();
        return;
      }
    });

    function checkDateValidation(filterStartDate, filterEndDate) {
      if (!filterStartDate || !filterEndDate) {
        alert("Både startdato og sluttdato er obligatorisk.");
        return false;
      }

      if (new Date(filterEndDate) < new Date(filterStartDate)) {
        alert("Sluttdato kan ikke være før startdato.");
        return false;
      }

      return true;
    }

    function getZreport(locationId, startDate, endDate, page) {
      $.ajax({
        type: "POST",
        url: "/api/v1/private/z-report/search",
        data: {
          location_id: locationId,
          start_date: startDate,
          end_date: endDate,
          page,
        },
      })
        .done(function (data) {
          if (data.html && data.html !== null && data.html !== "") {
            $("#z-report-list-view").empty();
            $("#z-report-list-view").html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.message !== undefined &&
            data.responseJSON.message !== null
          ) {
            $("#inventory-stock-history-response").empty();
            $("#inventory-stock-history-response").append(
              data.responseJSON.message
            );
          }
        });
    }

    $(document).on("click", "#download-all", function () {
      const start_date = $("#start-date").val();
      const end_date = $("#end-date").val();

      const disabledOnClick = $("#download-all");
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      const url = `/api/v1/z-report-public/download-all?start_date=${start_date}&end_date=${end_date}&location_id=${locationId}`;
      window.location.href = url;

      disabledOnClick.prop("disabled", false);
      disabledOnClick.html("Last ned alt som zip");
    });

    function parseNumberFromString(value) {
        if (typeof value === "string") {
            value = value.replace(",", ".");
        }
        return parseFloat(value) || 0;
    }

    function calculateBalanceAdjustment() {
        var cash = parseNumberFromString($('#cash').val());
        var cashSaved = parseNumberFromString($('#cash_takeout_saved').val());

        var newStartingBalance = cash - cashSaved;

        $('#new-cash-holding').text(newStartingBalance.toFixed(2).replace('.', ','));
    }
  }
});
